import Box from '@mui/material/Box';
import { FadeInChip } from './FadeInChip';
import { TAG_CHILDREN_MAP } from './tags';

type SearchTagsSectionProps = {
  selectedTags: string[];
  handleTagUpdate: (name: string) => void;
};

export const SearchTagsSection = ({
  handleTagUpdate,
  selectedTags,
}: SearchTagsSectionProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 2,
        mb: 3,
      }}
    >
      {selectedTags.map((tag) => {
        if (
          TAG_CHILDREN_MAP[`${tag}`] &&
          TAG_CHILDREN_MAP[`${tag}`].some((child) =>
            selectedTags.includes(child),
          )
        ) {
          TAG_CHILDREN_MAP[`${tag}`].map((child) => {
            return (
              <FadeInChip
                key={child}
                variant="search"
                tagName={child}
                handleTagUpdate={handleTagUpdate}
                selectedTags={selectedTags}
              />
            );
          });
        } else {
          return (
            <FadeInChip
              key={tag}
              variant="search"
              tagName={tag}
              handleTagUpdate={handleTagUpdate}
              selectedTags={selectedTags}
            />
          );
        }
        return null;
      })}
    </Box>
  );
};
